<template>
  <div class="comments">
    <div class="subscription-status">
      <v-btn
        v-if="!subscribed && subscribed !== false"
        flat
        icon
        disabled
      >
        <v-progress-circular
          v-if="!subscribed && subscribed !== false"
          indeterminate
          size="24"
          color="primary"
        >
        </v-progress-circular>
      </v-btn>

      <v-btn
        v-else-if="subscribed"
        flat
        icon
        title="Ви підписані на коментарі. Натисніть щоб відписатися."
        @click="$emit('unsubscribe')"
      >
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn v-else
        flat
        icon
        title="Ви не підписані на коментарі. Натисніть щоб підписатися."
        @click="$emit('subscribe')"
      >
        <v-icon>notifications_off</v-icon>
      </v-btn>
    </div>

    <h4>Коментарі</h4>

    <comments-level
      :comments="comments"
      :postId="postId"
      :auth="auth"
    ></comments-level>

    <div class="new-comment" >
      <div
        v-if="!addComment"
        @click="addComment = true"
        class="fake-comment"
      >
        <img v-if="auth.photoURL" :src="auth.photoURL" class="avatar"></img>
        <v-icon v-else x-large class="avatar default-avatar">account_circle</v-icon>

        <span>Додати коментар...</span>
      </div>
      <comment-form v-if="addComment" :postId="postId" :auth="auth" @cancel="addComment = false"></comment-form>
    </div>


  </div>
</template>

<script>

import { watchPostComments } from '@/firebase/helper';

import Comment from './Comment';
import CommentsLevel from './CommentsLevel';
import CommentForm from './CommentForm';

export default {
  name: 'comments',
  components: {
    Comment,
    CommentsLevel,
    CommentForm,
  },
  props: {
    postId: {
      required: true,
    },
    auth: {
      type: Object,
      required: true,
    },
    subscribed: true,
  },
  data() {
    return {
      commentsUnsubscriber: null,
      rawComments: [],
      comments: [],
      addComment: false,
    };
  },
  methods: {
    onCommentsUpdated(comments) {
      this.rawComments = comments;
      this.comments = this.getChildrenComments(null);
    },
    getChildrenComments(parentId) {
      return this.rawComments
        .filter(item => ((parentId && item.parentId === parentId) || (!parentId && !item.parentId)))
        .sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1))
        .map(item => ({ ...item, comments: this.getChildrenComments(item.id) }));
    },
  },
  mounted() {
    this.commentsUnsubscriber = watchPostComments(this.postId, this.onCommentsUpdated.bind(this));
  },
  beforeDestroy() {
    this.commentsUnsubscriber();
  },
};

</script>

<style scoped>

.comments {
  margin-top: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.new-comment {
  margin: 25px 0;
  padding: 20px 25px;
  background: #fcfcfc;
}

.fake-comment {
  color: #aaa;
  cursor: pointer;
}

.avatar {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.subscription-status {
  float: right;
  margin-right: -8px;
  margin-top: -5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Comments/Comments.vue